// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__2RpUp","toast_success":"Toast_toast_success__2Heo_","toast_error":"Toast_toast_error__3X24W"};